import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

const App = () => {
  const [pidCode, setPidCode] = useState("");
  const [generatedLink, setGeneratedLink] = useState("");
  const [timer1, setTimer1] = useState(0);
  const [timer2, setTimer2] = useState(0);
  const [isRunning1, setIsRunning1] = useState(false);
  const [isRunning2, setIsRunning2] = useState(false);

  // Timer 1 logic
  useEffect(() => {
    let interval1;
    if (isRunning1) {
      interval1 = setInterval(() => {
        setTimer1((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval1);
  }, [isRunning1]);

  // Timer 2 logic
  useEffect(() => {
    let interval2;
    if (isRunning2) {
      interval2 = setInterval(() => {
        setTimer2((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval2);
  }, [isRunning2]);

  // Format hh:mm:ss
  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  // Update tab title
  useEffect(() => {
    if (isRunning1) {
      document.title = `${formatTime(timer1)}`;
    } else if (isRunning2) {
      document.title = `${formatTime(timer2)}`;
    } else {
      document.title = "Start Survey";
    }
  }, [timer1, timer2, isRunning1, isRunning2]);

  // Generate new link
  const handleGenerateLink = () => {
    const uniqueId = uuidv4();
    let finalLink = "";

    if (pidCode.includes("[%%pid%%]")) {
      finalLink = pidCode.replace("[%%pid%%]", "") + uniqueId;
    } else {
      finalLink = pidCode + uniqueId;
    }

    setGeneratedLink(finalLink);
  };

  // Handle link click + reset timers
  const handleLinkClick = (e) => {
    e.preventDefault();
    if (!generatedLink) return;

    // Add localhost if missing http
    const finalLink = generatedLink.startsWith("http")
      ? generatedLink
      : `http://localhost:3001/${generatedLink}`;

    window.open(finalLink, "_blank", "noopener,noreferrer");

    setIsRunning1(false);
    setIsRunning2(false);
    setTimer1(0);
    setTimer2(0);

    setTimeout(() => {
      setIsRunning1(true);
    }, 2000);
  };

  const handleTimer1Toggle = () => {
    if (isRunning1) {
      setIsRunning1(false);
      setIsRunning2(true);
    } else {
      setIsRunning1(true);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        background: "linear-gradient(170deg, #002fffff, #5d7cf6ff)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        fontFamily: "'Poppins', sans-serif",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Floating glowing circles */}
      <div
        style={{
          position: "absolute",
          width: "400px",
          height: "400px",
          borderRadius: "50%",
          background: "rgba(255,255,255,0.08)",
          top: "-100px",
          left: "-100px",
          filter: "blur(80px)",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          width: "500px",
          height: "500px",
          borderRadius: "50%",
          background: "rgba(255,255,255,0.06)",
          bottom: "-150px",
          right: "-150px",
          filter: "blur(100px)",
        }}
      ></div>

      {/* Timers */}
      <div style={{ position: "absolute", top: 20, left: 20 }}>
        <div
          style={{
            background: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(8px)",
            padding: "10px 20px",
            borderRadius: "12px",
            textAlign: "center",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          }}
        >
          <h3 style={{ margin: 10 }}>{"Qualification Timer"}</h3>
          <h3 style={{ margin: 10 }}>{formatTime(timer1)}</h3>
          <button
            onClick={handleTimer1Toggle}
            style={{
              marginTop: "5px",
              background: "#fff",
              color: "#764ba2",
              border: "none",
              borderRadius: "8px",
              padding: "8px 25px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {isRunning1 ? "Stop" : "Start"}
          </button>
        </div>
      </div>

      <div style={{ position: "absolute", top: 20, right: 20 }}>
        <div
          style={{
            background: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(8px)",
            padding: "10px 20px",
            borderRadius: "12px",
            textAlign: "center",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          }}
        >
          <h3 style={{ margin: 10 }}>{"Main Survey Timer"}</h3>
          <h3 style={{ margin: 10 }}>{formatTime(timer2)}</h3>
          <button
            onClick={() => setIsRunning2(!isRunning2)}
            style={{
              marginTop: "5px",
              background: "#fff",
              color: "#667eea",
              border: "none",
              borderRadius: "8px",
              padding: "8px 25px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {isRunning2 ? "Stop" : "Start"}
          </button>
        </div>
      </div>

      {/* Logo */}
      <img
        src="http://teqluctechnologies.com/assets/images/logos/logo-dark.png"
        alt="Logo"
        style={{
          width: "180px",
          marginBottom: "60px",
          filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
        }}
      />

      {/* Generated Link */}
      {generatedLink && (
        <div
          style={{
            background: "rgba(255,255,255,0.15)",
            padding: "12px 20px",
            borderRadius: "10px",
            marginBottom: "20px",
            textAlign: "center",
            backdropFilter: "blur(6px)",
          }}
        >
          <a
            href={generatedLink}
            onClick={handleLinkClick}
            style={{
              color: "#fff",
              fontWeight: "500",
              textDecoration: "underline",
              fontSize: "16px",
              wordBreak: "break-all",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
          >
            {generatedLink}
          </a>
        </div>
      )}

      {/* Input + Button */}
      <div
        style={{
          width: "100%",
          maxWidth: "800px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "15px",
          background: "rgba(255,255,255,0.15)",
          backdropFilter: "blur(8px)",
          padding: "50px",
          borderRadius: "20px",
          // boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
        }}
      >
        <input
          type="text"
          placeholder="Enter your survey link here"
          value={pidCode}
          onChange={(e) => setPidCode(e.target.value)}
          style={{
            width: "100%",
            padding: "12px 16px",
            borderRadius: "10px",
            border: "none",
            outline: "none",
            fontSize: "16px",
            textAlign: "center",
            color: "#333",
          }}
        />
        <button
          onClick={handleGenerateLink}
          style={{
            background: "#1800f1ff",
            color: "#fff",
            border: "none",
            padding: "12px 25px",
            borderRadius: "30px",
            fontWeight: "600",
            fontSize: "16px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            width: "40%",
            marginTop: "20px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
          }}
          onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
          onMouseOut={(e) => (e.target.style.transform = "scale(1.0)")}
        >
          Start Survey
        </button>
      </div>
    </div>
  );
};

export default App;
